<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .module-icon {
    width: utils.in_rem(35.2px);
    height: utils.in_rem(35.2px);
    border-radius: utils.in_rem(5px);
    object-fit: contain;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
</style>

<script>
  import { capitalize } from "../../../../../assets/js/src/general/utils";
  let { license } = $props();

  let mod = $derived(capitalize(license));
</script>

<img
  src="/assets/img/modules/{license}.png"
  alt="{mod} icon"
  class="module-icon"
/>
